export default __webpack_public_path__ + "static/about-mobile-thin-icon-d869a305837318e01ac3ecc3d8e4dfa6.png";